import { createContext, useContext } from 'react'

export interface MediaValues {
  isMobileView: boolean
  isKeyboardOpen?: boolean
}

export const MediaContext = createContext<MediaValues>({
  isMobileView: true,
})

export const useMediaContext = () => useContext(MediaContext)
